import { GLOBAL } from 'saddlebag-browser';

class CookieConnector {
  constructor(sessionOnly) {
    this.DEFAULT_COOKIE_NAME = 'storageFallback';
    this.COOKIE_EXPIRY_VALUE = 7776000000; // 90 days
    this.sessionOnly = sessionOnly;
    this.$document = GLOBAL.getDocument();
  }

  getRawCookie(cookieName) {
    const rawCookie = this.$document.cookie.split(';');
    const nullableRawCookie = rawCookie.filter(
      (cookie) => cookie.trim().indexOf(cookieName) === 0,
    );

    if (!nullableRawCookie.length) {
      return {};
    }

    const parts = nullableRawCookie[0].split('=');
    if (parts.length !== 2) {
      return null;
    }
    return JSON.parse(parts[1]);
  }

  setRawCookie(cookieName, cookieValue, sessionOnly, expiry) {
    let cookieString = `${cookieName}=${cookieValue}`;
    if (!sessionOnly) {
      let expiryDate = expiry;
      if (!expiryDate) {
        expiryDate = new Date();
        expiryDate.setTime(expiryDate.getTime() + this.COOKIE_EXPIRY_VALUE);
      }
      cookieString += `; expires=${expiryDate.toUTCString()}`;
    }
    this.$document.cookie = cookieString;
    return this.$document.cookie;
  }

  getItem(namespace) {
    const cookieValue = this.getRawCookie(this.DEFAULT_COOKIE_NAME);
    if (cookieValue) {
      return JSON.stringify(cookieValue[namespace]);
    }
    return null;
  }

  setItem(namespace, value) {
    const cookieValue = this.getRawCookie(this.DEFAULT_COOKIE_NAME);
    if (!cookieValue) {
      return null;
    }
    cookieValue[namespace] = JSON.parse(value);
    return this.setRawCookie(
      this.DEFAULT_COOKIE_NAME,
      JSON.stringify(cookieValue),
      this.sessionOnly,
    );
  }

  createOrUpdateCookie(name, value, expiryDate) {
    return this.setRawCookie(name, value, false, expiryDate);
  }
}

export default CookieConnector;
